import script from "./DeliveryAnswerIssues.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeliveryAnswerIssues.vue?vue&type=script&lang=ts&setup=true"

import "./DeliveryAnswerIssues.vue?vue&type=style&index=0&id=061da05e&lang=less&scoped=true"

import exportComponent from "/var/build/production/construction-site-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-061da05e"]])

export default __exports__